import type { FormEachNode } from '../../../types/layout';

/** Opt-in banded table chrome (`tableHeaderStyle: "banded"`) — Surface shell + gray header band. */
export function usesBandedTablePresentation(node: FormEachNode): boolean {
  return node.tableHeaderStyle === 'banded';
}
